var _path, _path2, _path3, _path4, _circle, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4309 15.0945C45.7134 19.7824 47.0862 25.5449 46.27 31.2092C45.4537 36.8735 42.5098 42.0139 38.0373 45.5842C33.5648 49.1546 27.8999 50.8865 22.1955 50.4275C16.4911 49.9686 11.176 47.3532 7.3319 43.1137C3.48777 38.8742 1.40355 33.3293 1.50343 27.6073C1.6033 21.8854 3.87977 16.4165 7.86951 12.3138C11.8593 8.21105 17.2624 5.78277 22.9793 5.52316C28.6962 5.26356 34.2973 7.19214 38.6424 10.9164",
    stroke: "#799AA9",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8777 19.6831C37.9931 22.7042 38.8778 26.4178 38.3518 30.0681C37.8257 33.7184 35.9285 37.0312 33.0463 39.332C30.164 41.6329 26.5133 42.7491 22.8371 42.4533C19.161 42.1575 15.7357 40.4721 13.2583 37.7399C10.781 35.0078 9.43784 31.4344 9.50221 27.7469C9.56657 24.0595 11.0336 20.5351 13.6048 17.8911C16.176 15.2471 19.658 13.6822 23.3422 13.5149C27.0265 13.3476 30.636 14.5905 33.4362 16.9906",
    stroke: "#799AA9",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.236L23.106 25.447C22.884 25.004 22.499 24.367 21.954 23.852C21.418 23.345 20.776 23 20 23C18.324 23 17 24.326 17 25.92C17 27.131 17.554 27.986 18.868 29.29C19.205 29.624 19.589 29.985 20.014 30.383C21.122 31.423 22.5 32.717 24 34.447C25.5 32.717 26.878 31.423 27.986 30.383C28.411 29.985 28.796 29.623 29.132 29.29C30.446 27.986 31 27.131 31 25.92C31 24.326 29.676 23 28 23C27.223 23 26.582 23.345 26.046 23.852C25.501 24.367 25.116 25.004 24.894 25.447L24 27.236ZM24.392 35.528C24.3438 35.585 24.2838 35.6309 24.2161 35.6623C24.1484 35.6938 24.0747 35.7101 24 35.7101C23.9253 35.7101 23.8516 35.6938 23.7839 35.6623C23.7162 35.6309 23.6562 35.585 23.608 35.528C22.007 33.626 20.558 32.266 19.365 31.147C17.3 29.208 16 27.989 16 25.92C16 23.755 17.79 22 20 22C21.6 22 22.719 23.05 23.404 24.008C23.664 24.373 23.862 24.724 24 25C24.173 24.6546 24.3722 24.3229 24.596 24.008C25.281 23.049 26.4 22 28 22C30.21 22 32 23.755 32 25.92C32 27.989 30.7 29.208 28.635 31.147C27.442 32.267 25.993 33.627 24.392 35.527V35.528Z",
    fill: "#799AA9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29L52.2843 0.715729",
    stroke: "#799AA9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 29,
    r: 1,
    fill: "#799AA9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 10.5,
    x2: 47,
    y2: 10.5,
    stroke: "#799AA9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 10.5454,
    x2: 42.5,
    y2: 5.99996,
    stroke: "#799AA9"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 7.5,
    x2: 50,
    y2: 7.5,
    stroke: "#799AA9"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 45.5,
    y1: 7.54541,
    x2: 45.5,
    y2: 2.99996,
    stroke: "#799AA9"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 4.5,
    x2: 53,
    y2: 4.5,
    stroke: "#799AA9"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 48.5,
    y1: 4.54541,
    x2: 48.5,
    y2: -0.0000443459,
    stroke: "#799AA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/Goal.369fe88ab0c307c8182652a7381897e6.svg";
export { ForwardRef as ReactComponent };